export default __webpack_public_path__ + "static/media/HelveticaNeue.6936ad61.woff2";